export { CorrosionClasInput } from './CorrosionClasInput';
export { CorrosionClasOutput } from './CorrosionClasOutput'; 
export { CorrosionClas } from './CorrosionClass';